var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"element-link"},[(_vm.elementIcon)?_c('Icon',{attrs:{"name":_vm.elementIcon}}):_vm._e(),(_vm.isLoading)?_c('div',{staticClass:"loading-link-text"},[_c('TextLoader')],1):_c('router-link',{attrs:{"to":`/${_vm.element}/${_vm.id}`}},[_vm._v(_vm._s(_vm.elementName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }